import { Component, OnInit,ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder,FormControl, Validators,AbstractControl, FormArray } from '@angular/forms';
import { Invoice } from 'app/shared/types/invoice';
import { ActivatedRoute,Router} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { InvoiceService } from 'app/shared/services/invoice.service';
import { ItemService } from 'app/shared/services/item.service';
import { CustomerService} from 'app/shared/services/customer.service';
import { AuthService } from 'app/shared/services/auth.service';
import { map, startWith } from 'rxjs/operators';
import { Observable} from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { CanvasImageService} from 'app/shared/services/canvas-image.service';
import { CompanyProfileService } from 'app/shared/services/company-profile.service';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { DecimalPipe } from '@angular/common';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import * as moment from 'moment';
import { NbThemeService } from '@nebular/theme';

@Component({
  selector: 'app-sale-return',
  templateUrl: './sale-return.component.html',
  styleUrls: ['./sale-return.component.css']
})
export class SaleReturnComponent implements OnInit {

 
  datepickerConfig : Partial<BsDatepickerConfig>
  defaultDate : Date = new Date();
  isDark: boolean = false;

  itemList : any[]=[];
  filteredOptions:  Observable<any[]>[] = [];

  filteredCustomerList: Observable<any[]>;
  customerList : any[];
  warehouseList: any[];

  companyData : any  = [];
  logo :any;

  invoice:Invoice;
  invoiceData = [];
  stockData = [];
  invoiceForm: FormGroup;
  isfieldReadOnly : boolean= true;
  isBtnDisabled : boolean= false;
  isShowAttachBtn: boolean=false;
  isHideBtn: boolean= false;
  isCancelBtnDisabled : boolean= false;
  showInvoicePmtDetails : boolean= false;
  bsClassToShow : boolean = false;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;
  autoCompleteEnabled: boolean=false;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };


  validationMessages = {
    'invoiceNo': { 'required': 'Invoice number is required' },
    'invoiceDate': { 'required': 'Invoice date is required' }, 
    'cusId': {'required': 'Customer Id is required' },  
    'cusName': {'required': 'Customer is required' },
    'address': {'required': 'Address is required' },
  };

  formErrors = {
    'invoiceNo': "",
    'invoiceDate': "",
    'cusId':"",
    'cusName': "",
    'address': "",
  };



  constructor(private fb: FormBuilder,
        private invoiceService: InvoiceService,
        private authService: AuthService,
        private toastr: ToastrService,
        private dialogService: DialogService,
        private fileUploadService:FileUploadService,
        private itemService : ItemService,
        private route : ActivatedRoute,
        private router : Router, 
        private customerService : CustomerService,
        private decimalPipe: DecimalPipe,
        private themeService: NbThemeService,
        private companyProfileService: CompanyProfileService,
        private canvasImageService  : CanvasImageService )
      {
        this.datepickerConfig = Object.assign({},
          {   
            showWeekNumbers:false,
            dateInputFormat : 'YYYY-MM-DD'
          });
      }

  ngOnInit() {
   
      this.initInvoceType();
      this.initFormFields();

      this.getItemList();

      this.isBtnDisabled = true;
      this.isCancelBtnDisabled = true;
    
      this.getCustomerList();
      this.disableForm();
      this.getCompanyDetails();
      this.viewInvoiceById();
      this.autoCompleteCustomer();
      this.getControlPermissions();
      this.invoiceForm.valueChanges.subscribe((data) => {
        this.logValidationErrors(this.invoiceForm);
        });

        this.themeService.onThemeChange()
        .subscribe(themeName =>{
             this.isDark  = themeName.name ==='dark' ? true : false;
           });

  }// end oninit

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='SR'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }

  loadLogo(){
    
    if(this.companyData.length===1){
      if(this.companyData[0].Logo){
        let TYPED_ARRAY = new Uint8Array(this.companyData[0].Logo.data);
        const STRING_CHAR = TYPED_ARRAY.reduce((data,byte) =>{
          return data + String.fromCharCode(byte);
        },'');
        let base64String = btoa(STRING_CHAR);
        this.logo = 'data:image/jpeg;base64,' + base64String;
       }else{
        this.logo =null;
       }
  
       if(this.companyData[0].DigitalSignature){
        let TYPED_ARRAY = new Uint8Array(this.companyData[0].DigitalSignature.data);
        const STRING_CHAR = TYPED_ARRAY.reduce((data,byte) =>{
          return data + String.fromCharCode(byte);
        },'');
        let base64String = btoa(STRING_CHAR);
        //this.signature = 'data:image/jpeg;base64,' + base64String;
       }else{
        //this.signature =null;
       }

    } 
  
   
  }

  
    


  getCompanyDetails(){

    this.companyProfileService.getCompanyDetails()
    .subscribe(
      (data) =>{

                this.companyData = data;      
                this.loadLogo();      

                },
      (err) => {
        if(err instanceof HttpErrorResponse){                 
          if(err.status == 401){
            this.router.navigate(['/login']);
          }
        }
        console.log(err);
      }
    );
  
  }

  isNumeric(value){
    if(!isNaN(value) &&  !isNaN(parseFloat(value))){
      return true;
    } 
     return false;
  
  }


  autoComplete(index: number){
    this.filteredOptions[index] =this.getInvoiceItems.at(index).get('itemCode').valueChanges
    .pipe(
      startWith(''),
        map(value => this._filter(value))
    );

  }

  autoCompleteCustomer(){
      this.filteredCustomerList = this.invoiceForm.get('cusName').valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterCustomer(value))
      ); 
      
    
  }

  private _filter(itemCode: string): any[] {
    if(itemCode){
    const filterValue = itemCode.toLowerCase();
    return this.itemList.filter(option => option.ItemCode.toLowerCase().indexOf(filterValue) === 0);
    }
  }
  
  private _filterCustomer(cusName: string): any[] {
    if(cusName){
       const filterValue = cusName.toLowerCase();
       return this.customerList.filter(option => option.CusName.toLowerCase().indexOf(filterValue) === 0);
    }
  }

  getItemData(i){
    var filteredData;
    var value  = this.getInvoiceItems.at(i).get('itemCode').value;
    if(value){
    filteredData = this.itemList.filter(itemList =>itemList.ItemCode.toLowerCase()===value.toLowerCase());
    if(filteredData.length ===1){
        this.getInvoiceItems.at(i).patchValue({ 
          description : filteredData[0].Description,
          salesType : filteredData[0].Category,
          unitCost : filteredData[0].UnitCost,
          unitPrice : this.isNumeric(filteredData[0].UnitPrice) ? (filteredData[0].UnitPrice*-1) : filteredData[0].UnitPrice,
          qty :'1.00',        
          amount : this.isNumeric(filteredData[0].UnitPrice) ? (filteredData[0].UnitPrice*-1) : filteredData[0].UnitPrice,
        });     
    }else{
      this.getInvoiceItems.at(i).patchValue({ 
        description : '',
        salesType :  '',
        unitCost : '',
        unitPrice : '',
        qty :'',      
        amount : '',
      });     

    }
  }
}



getCustomerDetails(){      
  var filteredData;
  var cusName = this.invoiceForm.value.cusName;
  if(cusName){
  filteredData = this.customerList.filter(data =>data.CusName.toLowerCase()===cusName.toLowerCase());
   if(filteredData.length ===1){
     this.invoiceForm.patchValue({
       cusId : filteredData[0].CusId,
       address :filteredData[0].Address,
     });
   }else{
    this.invoiceForm.patchValue({
      cusId : null,
      address :null,
    });
   }
  }
}
     
  
getItemList(){
  this.itemService.getAll()
 .subscribe(
    (data) => {
              this.itemList = data                
              },
   (err) => 
            {
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            });  
   
 }

  getCustomerList(){
  this.customerService.getAll()
   .subscribe(
      (data) => {
                this.customerList = data.filter((el)=>{
                  return el.Status !=="Deactivated";
                });             
                },
     (err) => 
              {
                if(err instanceof HttpErrorResponse){                 
                  if(err.status == 401){
                    this.router.navigate(['/login']);
                  }
                }
                console.log(err);
              });  
     
   }


  

  initInvoceType() : void{

    this.invoice = {
      id : null,
      invoiceNo: '',
      invoiceDate: '',
      invoiceType: '',
      cusId: '',
      cusName: '',
      address: '',
      factoryLocation: '',
      requestedBy: '',
      vatNo: '',
      svatNo: '',
      poNo: '',
      vehicle: '',
      vehicleType: '',
      containerType: '',
      containerNo: '',
      fromLocation: '',
      toLocation: '',
      hireType: '',
      hireMode: '',
      requestTime: '',
      factoryInTime: '',
      detentionStartTime: '',
      finishedTime: '',
      chargingHours: 0.00,
      jobNo: '',
      paymentTerm: '',
      dueDate: '',
      itemCode: '',
      description: '',
      salesType: '',
      unitPrice: 0.00,
      qty: 0.00,
      amount: 0.00,
      subTotal: 0.00,
      vat: 0.00,
      grandTotal: 0.00,
      totalCost: 0.00,
      totalProfit: 0.00,
      balToPay: 0.00,
      amountPaid: 0.00,
      remarks: '',
      status: '',
      type: '',
      refNo: '',
      createdBy: '',
      

    };
  }

  initFormFields() : void{
    this.invoiceForm = this.fb.group({
      id : [null],
      invoiceNo : ['',Validators.required],
      invoiceDate : ['',Validators.required],
      refNo : [''],
      cusId : [''],
      cusName : [null,Validators.required],
      address : ['',Validators.required],
      invoiceItems : this.fb.array([this.addInvoiceItem()]), 
       
    });


  }


  newButtonClick(): void {
    this.isfieldReadOnly  = false;
    this.isBtnDisabled = false;
    this.isCancelBtnDisabled = true;
    this.isShowAttachBtn=false;
    this.autoCompleteEnabled = true;
    this.isHideBtn = false;
    this.invoiceForm.reset();
    this.resetOtherControls();
    this.enableForm();
    this.getReturnNo();
    this.addItemButtonClick();
    this.invoiceForm.patchValue({
      invoiceDate:  this.defaultDate
    });
     
   }

   getReturnNo(){
    var invoiceNo = 0;
    var invNoPrefixZero  : String;
  
    this.invoiceService.getReturnNo()
    .subscribe(
      (res) => {
          invoiceNo = Number(res[0].InvoiceNo) + 1;
          invNoPrefixZero = invoiceNo.toString().padStart(6,'0');       
          this.invoiceForm.patchValue({
            invoiceNo : "CN" + invNoPrefixZero
          });
         
      },        
      (err) =>  {
                if(err instanceof HttpErrorResponse){                 
                  if(err.status == 401){
                    this.router.navigate(['/login']);
                  }
                }
                console.log(err);
           }, 
      )

   }
  
   addInvoiceItem() : FormGroup{
     
    return this.fb.group({
     itemCode : ['',Validators.required],
     description : ['',Validators.required],
     salesType : ['',Validators.required],
     unitCost : [''],
     unitPrice :['',Validators.required],
     qty : ['',Validators.required],
     amount : ['',Validators.required],

    });
   
  }


   get getInvoiceItems(){
      return this.invoiceForm.get('invoiceItems') as FormArray;
   }

   addItemButtonClick() : void {
      this.getInvoiceItems.push(this.addInvoiceItem());
      this.autoComplete(this.getInvoiceItems.length-1);
      this.updateBillTotal();  
   }

    removeItemButtonClick(itemIndex : number) : void{
      this.getInvoiceItems.removeAt(itemIndex);
      this.filteredOptions.splice(itemIndex, 1);
      this.updateBillTotal()
    }

    resetOtherControls() : void{
        while (this.getInvoiceItems.length !== 0) {
          this.getInvoiceItems.removeAt(0);
        }

        this.invoice.subTotal = 0.00;
        this.invoice.vat = 0.00;
        this.invoice.grandTotal = 0.00;
        this.showInvoicePmtDetails = false;
        this.bsClassToShow = false;
    }

 
    
  
    covertAmountsToMinus(i){
      var unitPrice = parseFloat(this.getInvoiceItems.at(i).get('unitPrice').value);
      var qty =  parseFloat(this.getInvoiceItems.at(i).get('qty').value);
       if(unitPrice && qty){
         if(unitPrice>0){
         unitPrice *=-1;
         this.getInvoiceItems.at(i).patchValue({unitPrice : unitPrice.toString(), });    
         }
       }
       this.calEachItemAmount(i);
     }
   

     calEachItemAmount(i){
      var unitPrice : number;
      var qty : number;
      var amount : number=0;
      
      var itemCode  = this.getInvoiceItems.at(i).get('itemCode').value
      if(itemCode){

      unitPrice = this.isNumeric(this.getInvoiceItems.at(i).get('unitPrice').value) ? parseFloat(this.getInvoiceItems.at(i).get('unitPrice').value) :null;
      qty = this.isNumeric(this.getInvoiceItems.at(i).get('qty').value) ?  parseFloat(this.getInvoiceItems.at(i).get('qty').value) : null;
      amount = (this.isNumeric(unitPrice) && this.isNumeric(qty)) ? parseFloat((unitPrice * qty).toFixed(2)) : null;

      this.getInvoiceItems.at(i).patchValue({unitPrice : unitPrice});
      this.getInvoiceItems.at(i).patchValue({qty : qty});
      this.getInvoiceItems.at(i).patchValue({amount : amount});


      }
  
      this.updateBillTotal();
    }


  updateBillTotal(){
    this.invoice.grandTotal = this.getInvoiceItems.value.reduce((prev,curr)=>prev + +curr.amount, 0);
  }


  mapFormValuesToModel(){
    this.invoiceData =[];
   var resultInvoice = [];

    for(let i=0; i < this.getInvoiceItems.length; i++){

    this.invoice.invoiceNo=this.invoiceForm.value.invoiceNo;
    this.invoice.invoiceDate=this.invoiceForm.value.invoiceDate;
    this.invoice.invoiceType=null;
    this.invoice.cusId=this.invoiceForm.value.cusId;
    this.invoice.cusName=this.invoiceForm.value.cusName;
    this.invoice.address=this.invoiceForm.value.address;
    this.invoice.factoryLocation=null;
    this.invoice.requestedBy=null;
    //this.invoice.vatNo=this.invoiceForm.value.vatNo;
    //this.invoice.svatNo=this.invoiceForm.value.svatNo;
    this.invoice.vehicle=null;
    this.invoice.vehicleType=null;
    this.invoice.containerType=null;
    this.invoice.containerNo=null;
    this.invoice.fromLocation=null;
    this.invoice.toLocation=null;
    this.invoice.hireType=null;
    this.invoice.hireMode=null;
    this.invoice.requestTime=null;
    this.invoice.factoryInTime=null;
    this.invoice.detentionStartTime=null;
    this.invoice.finishedTime=null;
    this.invoice.chargingHours=null;
    this.invoice.jobNo=null;
    this.invoice.paymentTerm='COD'
    this.invoice.dueDate= null;


    this.invoice.itemCode = this.getInvoiceItems.value[i].itemCode
    this.invoice.description=this.getInvoiceItems.value[i].description;
    this.invoice.salesType=this.getInvoiceItems.value[i].salesType;
    this.invoice.unitPrice=this.getInvoiceItems.value[i].unitPrice;
    this.invoice.qty=this.getInvoiceItems.value[i].qty;
    this.invoice.amount=this.getInvoiceItems.value[i].amount;

    this.invoice.subTotal=this.invoice.subTotal;
    this.invoice.vat =this.invoice.vat;
    this.invoice.grandTotal=this.invoice.grandTotal;
    this.invoice.totalCost = this.getInvoiceItems.value.reduce((prev,curr)=>prev + +(curr.unitCost * curr.qty), 0);
    this.invoice.totalProfit=this.invoice.grandTotal - this.invoice.totalCost;
    this.invoice.balToPay=this.invoice.grandTotal;
    this.invoice.amountPaid=0.00;

    this.invoice.status='Unpaid';
    this.invoice.type='Credit Note';
    this.invoice.refNo=this.invoiceForm.value.refNo;
    this.invoice.createdBy =this.authService.getUserLoggedIn();
    
    this.invoiceData.push(
      this.invoice.invoiceNo,
      this.invoice.invoiceDate,
      this.invoice.invoiceType,
      this.invoice.cusId,
      this.invoice.cusName,
      this.invoice.address,
      this.invoice.factoryLocation,
      this.invoice.requestedBy,
      this.invoice.vatNo,
      this.invoice.svatNo,
      this.invoice.vehicle,
      this.invoice.vehicleType,
      this.invoice.containerType,
      this.invoice.containerNo,
      this.invoice.fromLocation,
      this.invoice.toLocation,
      this.invoice.hireType,
      this.invoice.hireMode,
      this.invoice.requestTime,
      this.invoice.factoryInTime,
      this.invoice.detentionStartTime,
      this.invoice.finishedTime,
      this.invoice.chargingHours,
      this.invoice.jobNo,
      this.invoice.paymentTerm,
      this.invoice.dueDate, //26
   
          
      this.invoice.itemCode,
      this.invoice.description,
      this.invoice.salesType,
      this.invoice.unitPrice,
      this.invoice.qty,
      this.invoice.amount, //32

      this.invoice.subTotal,   
      this.invoice.vat,
      this.invoice.grandTotal,
      this.invoice.totalCost,
      this.invoice.totalProfit,
      this.invoice.balToPay,
      this.invoice.amountPaid, //39

      this.invoice.status,
      this.invoice.type,
      this.invoice.refNo,
      this.invoice.createdBy,  //43

      );

    }

    while(this.invoiceData.length){
      resultInvoice.push(this.invoiceData.splice(0,43));
    }


    return [resultInvoice];

  }

   
  saveButtonClick(): void {
    this.logValidationErrors(this.invoiceForm,true);

    const [invoiceData] = this.mapFormValuesToModel();
    const body = {invoiceData : invoiceData};

    if(this.isFilledFromFields()){  
        this.showProcessingIndicator = true;
          this.invoiceService.addCreditNote(body)
          .subscribe(
            (res) =>{     
              if(res.success === 0){
                this.invoiceForm.patchValue({
                  invoiceNo : res.autoId
                });
              this.saveButtonClick();
              this.showProcessingIndicator = false; 
            }else if(res.success === 1){
              console.log(res);
              this.toastr.success('Credit Note created successfully','Success');
              this.isfieldReadOnly  = true;
              this.isBtnDisabled = true;
              this.isHideBtn = true;  
              this.isShowAttachBtn = true;
              this.isCancelBtnDisabled = false;
              this.disableForm(); 
              this.showProcessingIndicator = false;   
            }   
            },
            (err) =>{
              this.toastr.error('Failed to create credit note','Failure'); 
              this.showProcessingIndicator = false; 
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);  
            }
          )
        } 

    else{
          this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
          this.showProcessingIndicator = false;                                                                                                                                                                                                   
        } 
   }

   deleteButtonClick(){   
    var invoiceNo = this.invoiceForm.get('invoiceNo').value;
    if(invoiceNo){
    this.dialogService.openConfirmDialog('Are you sure you want to delete this credit Note?')
    .afterClosed().subscribe(res =>{
      if(res){
       const [invoiceData] = this.mapFormValuesToModel();
      const body = {invoiceData : invoiceData};
     this.invoiceService.deleteCreditNote(body,invoiceNo)
     .subscribe(
       (res) => {
                   this.toastr.success('Credit Note deleted successfully','Success');
                   this.newButtonClick();
                   console.log(res);     
                 },        
       (err) =>  {
                   this.toastr.error('Failed to delete credit note','Failure');
                   if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                 }, 
         )

     } 
   });
  }
}

   enableForm():void{
    Object.keys(this.invoiceForm.controls).forEach(key => {
      this.invoiceForm.controls[key].enable();
      //console.log("Enable "+key)     
    });

  }


  disableForm():void{
    Object.keys(this.invoiceForm.controls).forEach(key => {
      this.invoiceForm.controls[key].disable();
     // console.log("disable "+key);
    });

  }
  
  logValidationErrors(group: FormGroup = this.invoiceForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.invoiceForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }

  isFilledFromFields() : boolean {
    (<FormArray>this.invoiceForm.get('invoiceItems')).controls.forEach((group: FormGroup) => {
      (<any>Object).values(group.controls).forEach((control: FormControl) => { 
          control.markAsTouched();
      }) 
    });

    var value = this.invoiceForm.value.cusId;
    if(!value){
      this.invoiceForm.patchValue({ cusId :  null,cusName :  null, address : null });    
    }

    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }

       if(this.getInvoiceItems.length==0 || this.invoiceForm.get('invoiceItems').invalid){
          return false;
          }

        return true;
  }

 



    viewInvoiceById(){
        var hasInvoiceNo;
        var invoiceNo;

          hasInvoiceNo =this.route.snapshot.queryParamMap.has('returnNo');
         
          if(hasInvoiceNo){
            invoiceNo = this.route.snapshot.queryParamMap.get('returnNo')
            this.invoiceService.getInvoice(invoiceNo)
            .subscribe(
              (data) => {
                        if(data){                         
                          this.isCancelBtnDisabled = false;
                          this.patchValuesToForm(data); 
                          this.isBtnDisabled = true;
                          this.disableForm(); 
                          this.isfieldReadOnly = true; 
                          this.isShowAttachBtn = true;  
                          this.isHideBtn = true;                     
                          this.showInvoicePmtDetails = true;    
                          this.bsClassToShow = true;                     
                         }
                        },
            (err) => 
                      {
                        if(err instanceof HttpErrorResponse){                 
                          if(err.status == 401){
                            this.router.navigate(['/login']);
                          }
                        }
                        console.log(err);
                      });
      }else{
        this.newButtonClick();
      }


    }

patchValuesToForm(data){
  this.invoiceForm.patchValue({  
    invoiceNo : data[0].InvoiceNo,
    invoiceDate : moment(data[0].InvoiceDate).format("YYYY-MM-DD"),
    cusId : data[0].CusId,
    cusName : data[0].CusName,
    address : data[0].Address,
    refNo : data[0].RefNo,

  });
  
  this.invoiceForm.setControl('invoiceItems',this.setInvoiceItems(data));
  this.invoice.subTotal= data[0].SubTotal;
  this.invoice.vat = data[0].Vat;
  this.invoice.grandTotal = data[0].GrandTotal,

  this.invoice.status = data[0].Status;
  this.invoice.amountPaid = data[0].AmountPaid;
  this.invoice.balToPay = data[0].BalToPay;
  this.invoice.createdBy = data[0].CreatedBy;

  if(data[0].Status==='Paid'){
    this.isCancelBtnDisabled = true;
  }
  this.autoCompleteEnabled = false;
}


  setInvoiceItems(data) : FormArray{
    const invoiceItemArray = new FormArray([]);
    for(let i =0; i < data.length;i++){ 
      invoiceItemArray.push(this.fb.group({
        itemCode : [data[i].ItemCode],
        description : [data[i].Description], 
        salesType : [data[i].SalesType], 
        unitPrice : [data[i].UnitPrice],
        qty : [data[i].Qty],
        amount : [data[i].Amount],      
      }));
    }
    return invoiceItemArray;
  }

  attachFileButtonClick(){
    this.fileUploadService.refNo = this.invoiceForm.value.invoiceNo;
     const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.width = "75%";
     this.dialogService.openDialog(FileUploadComponent,dialogConfig);
        
    }
  
 

     savePDF(action){
     
    //   const documentDefinition = { 
    //     pageSize: 'A4',
    //     pageOrientation: 'portrait',  
    //     pageMargins: [40, 40, 40, 120],
        
    //     content: [ 
            
    //       {
    //         columns : [ 
              
    //                 { image:this.logo,            
    //                   width: 100,
    //                   height: 100,
    //                 },
  
    //               [                                         
    //                {
    //                 text: 'Sales Return',
    //                 color: '#333333',
    //                 width: '*',
    //                 fontSize: 30,
    //                 bold: true,
    //                 alignment: 'right',
    //                 margin: [0, 0, 0, 15],
    //               },
  
    //               {
    //                stack: [
    //                 {
    //                   columns: [
    //                     {
    //                       text: 'Return No. :',
    //                       color: '#aaaaab',
    //                       bold: true,
    //                       width: '*',
    //                       fontSize: 12,
    //                       alignment: 'right',
    //                     },
    //                     {
    //                       text: this.invoiceForm.value.invoiceNo,
    //                       bold: true,
    //                       color: '#333333',
    //                       fontSize: 12,
    //                       alignment: 'right',
    //                       width: 115,
    //                     },
    //                   ],
    //                 },
    //                 {
    //                   columns: [
    //                     {
    //                       text: 'Return Date :',
    //                       color: '#aaaaab',
    //                       bold: true,
    //                       width: '*',
    //                       fontSize: 12,
    //                       alignment: 'right',
    //                     },
    //                     {
    //                       text: moment(this.invoiceForm.value.invoiceDate).format("YYYY-MM-DD"),
    //                       bold: true,
    //                       color: '#333333',
    //                       fontSize: 12,
    //                       alignment: 'right',
    //                       width: 115,
    //                     },
    //                   ],
    //                 }, 
  
    //               ],
    //             },
    //           ],
    //         ],
    //       },              
  
    //       {
    //         columns : [
           
    //           [
                
    //             { text: 'Bill To :', margin: [0, 20, 0, 5], color: '#aaaaab',   fontSize: 12,},  
    //             { text: this.invoiceForm.value.cusName,margin: [0, 0, 0, 0], bold:true,   fontSize: 12, },  
    //             { text: this.invoiceForm.value.address,margin: [0, 0, 0, 0] },  
  
    //           ],
  
    //         ]
  
    //       },
  
    //       '\n\n',
                             
    //       {  
    //         layout: {
    //           defaultBorder: false,
    //           hLineWidth: function(i, node) {
    //             return 1;
    //           },
    //           vLineWidth: function(i, node) {
    //             return 1;
    //           },
    //           hLineColor: function(i, node) {
    //             if (i === 1 || i === 0) {
    //               return '#bfdde8';
    //             }
    //             return '#eaeaea';
    //           },
    //           vLineColor: function(i, node) {
    //             return '#eaeaea';
    //           },
    //           hLineStyle: function(i, node) {
    //             // if (i === 0 || i === node.table.body.length) {
    //             return null;
    //             //}
    //           },
    //           // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
    //           paddingLeft: function(i, node) {
    //             return 10;
    //           },
    //           paddingRight: function(i, node) {
    //             return 10;
    //           },
    //           paddingTop: function(i, node) {
    //             return 2;
    //           },
    //           paddingBottom: function(i, node) {
    //             return 2;
    //           },
    //           fillColor: function(rowIndex, node, columnIndex) {
    //             return '#fff';
    //           },
    //         },
    //         table: {  
               
    //             headerRows: 1,  
    //             widths: ['auto', '*', 'auto','auto', 'auto'],  
    //             body: [  
    //               [
    //                { text: 'ItemCode', style:'tableFont',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
    //                { text: 'Description', style:'tableFont',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
    //                { text: 'UnitPrice', style:'tableFont',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
    //                { text: 'Qty', style:'tableFont',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
    //                { text: 'Amount', style:'tableFont',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]}],
    //               ...this.getInvoiceItems.value.map(p => ([{ text :p.itemCode, border: [false, false, false, true],  margin: [0, 5, 0, 5],style:'tableFont'},{ text :p.description, border: [false, false, false, true],  margin: [0, 5, 0, 5],style:'tableFont'}, {text : this.transformNumberFormat(p.unitPrice), border: [false, false, false, true], margin: [0, 5, 0, 5], alignment: 'right',style:'tableFont' }, { text : this.transformNumberFormat(p.qty), border: [false, false, false, true],margin: [0, 5, 0, 5],alignment: 'right',style:'tableFont'  }, { text: this.transformNumberFormat(p.amount), border: [false, false, false, true],margin: [0, 5, 0, 5],alignment: 'right',style:'tableFont' }])),               
    //             ]           
    //       }       
    //     },
  
    //     '\n',
    //     '\n',
    //     {
    //       columns : [
    //                 {},
                         
    //             { 
    //               layout: {
    //               defaultBorder: false,
    //               hLineWidth: function(i, node) {
    //                 return 1;
    //               },
    //               vLineWidth: function(i, node) {
    //                 return 1;
    //               },
    //               hLineColor: function(i, node) {
    //                 return '#eaeaea';
    //               },
    //               vLineColor: function(i, node) {
    //                 return '#eaeaea';
    //               },
    //               hLineStyle: function(i, node) {
    //                 // if (i === 0 || i === node.table.body.length) {
    //                 return null;
    //                 //}
    //               },
    //               // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
    //               paddingLeft: function(i, node) {
    //                 return 10;
    //               },
    //               paddingRight: function(i, node) {
    //                 return 10;
    //               },
    //               paddingTop: function(i, node) {
    //                 return 3;
    //               },
    //               paddingBottom: function(i, node) {
    //                 return 3;
    //               },
    //               fillColor: function(rowIndex, node, columnIndex) {
    //                 return '#fff';
    //               },
    //             },
    //               width: 'auto', 
    //               fontSize: 12,            
    //               table: {
    //               headerRows: 1,
    //               widths: ['auto', 'auto'],
    //                   body: [
    //                   [
    //                     {
    //                       text: 'GrandTotal',
    //                       bold: true,
    //                       alignment: 'right',
    //                       border: [false, false, false, true],
    //                       margin: [0, 5, 0, 5],
    //                     },
    //                     {
    //                       text: this.transformNumberFormat(this.invoice.grandTotal),
    //                       bold: true,          
    //                       alignment: 'right',
    //                       border: [false, false, false, true],
    //                       fillColor: '#f5f5f5',
    //                       margin: [0, 5, 0, 5],
    //                     },
    //                   ],
 
    //                 ],
    //               },
    //             },         
    //       ]
  
    //     },
  
    //     // '\n','\n\n',  
    //     // '\n\n',    
  
    // ], // end contect

    // footer: ()=> {

    //   return [
      
    //     { margin: [40, 5, 40, 10],canvas: [{type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 } ]},
    //     {
    //       margin: [40, 5, 40, 20],
    //       columns : [
    //         [
    //           { text: 'Address',width: 'auto',bold: true, fontSize: 10},
    //           { text: this.companyData[0].CompanyName,width: 'auto',bold: true,fontSize: 10 },  
    //           { text: this.companyData[0].Address,width: 'auto', fontSize: 10 },   
    //         ],
    //         [
              
    //           { text: 'Contact Info',width: '*',bold: true, margin: [20, 0, 0, 0], fontSize: 10},
    //           { text: this.companyData[0].Phone,width: '*',margin: [20, 0, 0, 0], fontSize: 10 },  
    //           { text: this.companyData[0].MobileNo,width: '*',margin: [20, 0, 0, 0], fontSize: 10}, 
    //           { text: this.companyData[0].Email,width: '*',margin: [20, 0, 0, 0], fontSize: 10},
    //           { text: this.companyData[0].Web,width: '*',margin: [20, 0, 0, 0], fontSize: 10}    
    
    //         ],
    
    //       ]
    //     },
    
    //   ]
      
    //    },
  
        
     
    //     styles: {  
    //       reportHeader: {  
    //           bold: true,  
    //           decoration: 'underline',  
    //           fontSize: 14,  
    //           margin: [0, 15, 0, 15],
    //           alignment: 'center',             
    //       },
    //       tableFont: {  
    //         fontSize: 10,  
             
    //     }   
    //     } 
        
        
    //    };// end 
  
  
  
    //     if(action==='open'){    
    //           pdfMake.createPdf(documentDefinition).open();  
    //       }else if(action === 'print'){    
    //           pdfMake.createPdf(documentDefinition).print();          
    //       }
    //       else if(action === 'download'){    
    //         pdfMake.createPdf(documentDefinition).download(`Sales Return-${this.invoiceForm.value.invoiceNo}`);     
    //     }


     }
  
  
     transformNumberFormat(number) {
      return this.decimalPipe.transform(number,'1.2-2');
     }

}
